import React from "react";
import PropTypes from "prop-types";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";

export default function StyledPopover({
  pid,
  anchorEl,
  title,
  titleObject,
  open,
  onClose,
  anchorOrigin,
  ...props
}) {
  return (
    <Popover
      id={pid}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      slotProps={{
        paper: {
          sx: { boxShadow: "elevation3" },
        }
      }}
    >
      <Box sx={{ padding: "20px" }}>
        {title ? <Typography variant="subhead1">
          {title}
        </Typography>
          : titleObject}
        <Divider sx={{ margin: "10px 0 20px 0", backgroundColor: "black_solid.30" }} />
        {props.children}
      </Box>
    </Popover>
  );
}

StyledPopover.propTypes = {
  pid: PropTypes.string,
  anchorEl: PropTypes.object,
  title: PropTypes.string,
  titleObject: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  anchorOrigin: PropTypes.object,
  children: PropTypes.node
};